export default class ProductActualStatus {
  constructor(public id: string, public name: string) {}

  static fromServer(data: any): ProductActualStatus {
    return new ProductActualStatus(data.id, data.name);
  }

  toString() {
    return this.name;
  }
}
